import React from "react";

export const TanStackRouterDevtools =
    import.meta.env.MODE === "production"
        ? () => null
        : React.lazy(() =>
              // Lazy load in development
              import("@tanstack/router-devtools").then((res) => ({
                  default: res.TanStackRouterDevtools,
              }))
          );
